<template>
  <div class="app-container">
    <el-tabs v-model="tabName">
      <el-tab-pane label="配送区域" name="delivery">
        <list ref="list">
          <template slot="toolbar-right">
            <el-button
              size="mini"
              type="primary"
              @click="create"
              icon="el-icon-plus"
              v-if="$permission.canWrite()"
              >添加</el-button
            >
            <el-button
              size="mini"
              class="filter-item"
              type="danger"
              @click="delRows"
              v-if="$permission.canDel()"
              >删除</el-button
            >
          </template>
          <template slot="column">
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="80"
            >
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="edit(row)"
                  v-if="!$permission.canEdit()"
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="edit(row)"
                  v-if="$permission.canEdit()"
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="del(row.RecordId)"
                  v-if="$permission.canDel()"
                ></el-button>
              </template>
            </el-table-column>
          </template>
        </list>
      </el-tab-pane>
      <el-tab-pane label="不支持配送区域" name="undelivery">
        <unSupportlist ref="unSupportlist">
          <template slot="toolbar-right">
            <el-button
              size="mini"
              type="primary"
              @click="createUnSupport"
              icon="el-icon-plus"
              v-if="$permission.canWrite()"
              >添加</el-button
            >
            <el-button
              size="mini"
              class="filter-item"
              type="danger"
              @click="delRowsUnSupport"
              v-if="$permission.canDel()"
              >删除</el-button
            >
          </template>
          <template slot="column">
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="80"
            >
              <template slot-scope="{ row }">
               <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="detail(row)"
          
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  @click="delUnSupport(row.RecordId)"
                  v-if="$permission.canDel()"
                ></el-button>
              </template>
            </el-table-column>
          </template> </unSupportlist
      ></el-tab-pane>
    </el-tabs>

    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <editUnSupport-dialog
      ref="editUnSupportDialog"
      @close-saved="reload2"
    ></editUnSupport-dialog>
    <detail-dialog
      ref="detailDialog"
    ></detail-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sale/freight/list";
import unSupportlist from "@/components/sale/freight/unsupport/list";
import editDialog from "@/components/sale/freight/editDialog";
import editUnSupportDialog from "@/components/sale/freight/unsupport/editDialog";
import detailDialog from "@/components/sale/freight/unsupport/detailDialog";

export default {
  name: "freight",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    unSupportlist,
    editUnSupportDialog,
    detailDialog
  },
  data() {
    return {
      tabName: "delivery",
    };
  },
  methods: {
    reload2(){
      this.$refs.unSupportlist.query()
    },
    del(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.delRange([id]);
        })
        .catch(() => {});
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RecordId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    createUnSupport() {
      this.$refs.editUnSupportDialog.openCreate();
    },
    delUnSupport(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.unSupportlist.delRange([id]);
        })
        .catch(() => {});
    },
    delRowsUnSupport() {
      let rows = this.$refs.unSupportlist.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.RecordId;
          });
          this.$refs.unSupportlist.delRange(ids);
        })
        .catch(() => {});
    },
    detail(row){
            this.$refs.detailDialog.openEdit(row);
    }
  },
};
</script>